export const BusinessUnitData = `
  id
  name
  parentId
  status
  tenant
  businessDomainId
  businessDomain {
    id
    name
  }
  childrenIds
  categoryIds
  offeringProductGroupIds
  lastModifiedAt
`;
